import { IFilter, IFilterOption } from '../../interfaces/Filter.interfaces';

export interface IProductFilterOption extends IFilterOption {
  value: ProductFilterOptionValueType;
  description?: string;
  chip?: '할부 가능';
}

export type productFilterKeyType = 'sorter' | 'filter_category' | 'filter_status' | 'filter_brand';

export interface IProductFilter extends IFilter {
  key: productFilterKeyType;
  options: IProductFilterOption[];
}

export enum ProductFilterOptionValueSorterEnum {
  COMMON = 'common',
  price_asc = 'price_asc',
  manufacturedYear_desc = 'manufacturedYear_desc',
  operationTime_asc = 'operationTime_asc',
}

export enum ProductFilterOptionValueCategoryEnum {
  ALL = 'all',
  PLUVA = 'PLUVA',
  PARTNER = 'PARTNER',
}

export enum ProductFilterOptionValueStatusEnum {
  ALL = 'all',
  ONSALE = 'ONSALE,IN_CONTRACT',
}

type ProductFilterOptionValueType =
  | ProductFilterOptionValueSorterEnum
  | ProductFilterOptionValueCategoryEnum
  | ProductFilterOptionValueStatusEnum
  | string;

const productFilterSorterConstant: IProductFilter = {
  key: 'sorter',
  title: '정렬',
  optionType: 'radio',
  options: [
    { optionName: '기본 정렬순', value: ProductFilterOptionValueSorterEnum.COMMON, isDefault: true, isSelected: true },
    {
      optionName: '낮은 가격순',
      value: ProductFilterOptionValueSorterEnum.price_asc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '최근 연식순',
      value: ProductFilterOptionValueSorterEnum.manufacturedYear_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '짧은 사용시간순',
      value: ProductFilterOptionValueSorterEnum.operationTime_asc,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const productFilterCategoryConstant: IProductFilter = {
  key: 'filter_category',
  title: '판매자',
  optionType: 'radio',
  options: [
    { optionName: '판매자 전체', value: ProductFilterOptionValueCategoryEnum.ALL, isDefault: true, isSelected: true },
    {
      optionName: '플루바 매물',
      value: ProductFilterOptionValueCategoryEnum.PLUVA,
      isDefault: false,
      isSelected: false,
      chip: '할부 가능',
      description: '플루바가 보증하는 프리미엄 매물!',
    },
    {
      optionName: '파트너 매물',
      value: ProductFilterOptionValueCategoryEnum.PARTNER,
      isDefault: false,
      isSelected: false,
      chip: '할부 가능',
      description: '믿을 수 있는 협력사의 매물!',
    },
  ],
};

const productFilterStatusConstant: IProductFilter = {
  key: 'filter_status',
  title: '판매 상태',
  buttonTitle: '판매 상태로 보기',
  optionType: 'radio',
  options: [
    { optionName: '모든 매물', value: ProductFilterOptionValueStatusEnum.ALL, isDefault: true, isSelected: true },
    {
      optionName: '판매 중',
      value: ProductFilterOptionValueStatusEnum.ONSALE,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const productFilterBrandConstant: IProductFilter = {
  key: 'filter_brand',
  title: '브랜드',
  buttonTitle: '브랜드로 보기',
  optionType: 'checkbox',
  options: [],
};

export const productFiltersConstant: IProductFilter[] = [
  productFilterSorterConstant,
  productFilterBrandConstant,
  productFilterCategoryConstant,
  productFilterStatusConstant,
];
